/**
 * Debug mode indicator badge for the header.
 */

import { useSettingsStore } from '../../stores/settingsStore';

export function DebugBadge() {
  const debugMode = useSettingsStore((state) => state.debugMode);

  if (!debugMode) return null;

  return (
    <span className="px-2 py-0.5 text-xs font-semibold bg-yellow-500 text-gray-900 rounded">
      DEBUG
    </span>
  );
}
